/* eslint-disable import/first */
// --- ERROR SUPPRESSION START ---
const RO_ERRORS = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded'
];
const isROError = (err) => {
  if (!err) return false;
  if (typeof err === 'string') return RO_ERRORS.some(msg => err.includes(msg));
  if (err.message) return RO_ERRORS.some(msg => err.message.includes(msg));
  return false;
};
const originalConsoleError = console.error;
console.error = function (...args) {
  if (args.some(arg => isROError(arg))) return;
  originalConsoleError.apply(console, args);
};
window.addEventListener('error', (event) => {
  if (isROError(event) || isROError(event.message) || isROError(event.error)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);
window.addEventListener('unhandledrejection', (event) => {
  if (isROError(event.reason)) event.preventDefault();
});
const OriginalResizeObserver = window.ResizeObserver;
if (OriginalResizeObserver) {
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          window.setTimeout(() => {
            if (callback) {
              try { callback(entries, observer); } catch (e) { if (!isROError(e)) console.warn(e); }
            }
          }, 50);
        });
      });
    }
  };
}
// --- ERROR SUPPRESSION END ---

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Fonts/Fonts.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

reportWebVitals();
